export const checkTotal = (total, quantity) => (total / quantity).toFixed(2);
